import type { ParticipantBehaviour } from '@piccolohealth/pbs-common';
import { ChakraV3, DescriptionList } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { MethodTag } from './MethodTag';

interface Props {
  participantBehaviour: ParticipantBehaviour;
}

export const ParticipantBehaviourDataSummary = (props: Props) => {
  const { participantBehaviour } = props;

  const methods = [
    participantBehaviour.methods.abc,
    participantBehaviour.methods.duration,
    participantBehaviour.methods.frequency,
    participantBehaviour.methods.episodicSeverity,
  ].filter((method) => method.enabled);

  const items = [
    {
      title: 'Description',
      content: (
        <ChakraV3.Text fontSize='sm' lineClamp={2}>
          {participantBehaviour.description}
        </ChakraV3.Text>
      ),
    },
    {
      title: 'Example',
      content: (
        <ChakraV3.Text fontSize='sm' lineClamp={2}>
          {participantBehaviour.example}
        </ChakraV3.Text>
      ),
    },
    {
      title: 'Non-example',
      content: (
        <ChakraV3.Text fontSize='sm' lineClamp={2}>
          {participantBehaviour.nonExample}
        </ChakraV3.Text>
      ),
    },
    {
      title: 'Data methods',
      content: P.isEmpty(methods) ? (
        <ChakraV3.Text fontSize='sm'>No methods enabled</ChakraV3.Text>
      ) : (
        <ChakraV3.Wrap>
          {methods.map((method) => (
            <MethodTag key={`${participantBehaviour.id}-${method.__typename}`} method={method} />
          ))}
        </ChakraV3.Wrap>
      ),
    },
  ];

  return <DescriptionList items={items} />;
};
